import linkifyHtml from "linkify-html";
import * as calling from "../features/browser_chat/calling.js";

window.App || (window.App = {});
window.App.browserChat || (window.App.browserChat = {});
window.App.browserChat.calling = calling;

window.App.util || (window.App.util = {});
window.App.util.linkifyHtml = linkifyHtml;
